import { Box, Button, Container, Typography } from "@mui/material"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import { useNavigate } from "react-router-dom"

/**
 * Component NotFound
 *
 * display 404 page with go back to home button
 */
export default function NotFound() {
  let navigate = useNavigate()
  return (
    <Container id={"NotFound_container"}>
      <Box sx={{ textAlign: "center", mt: 4 }}>
        <Typography variant="h1">404</Typography>
        <Typography variant="sub5">Page not found</Typography>
        <br />
        <br />
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => {
            navigate(-1)
          }}
          sx={{ p: 1 }}
        >
          Go back
        </Button>
      </Box>
    </Container>
  )
}
